var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotjar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "102.05mm",
    height: "114.12mm",
    viewBox: "0 0 289.27 323.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M198.6,314.4c23.9-85.7,15.3-128.9-26.6-137.2,6.4,29.1,13.6,59-17,79.2-16,10.6-28.7,6.5-57.1-15.3-13.1,26.9-8.7,53.7-2.6,82.4-40.7-7.1-72.8-24-87.7-63.3A93.55,93.55,0,0,1,28.7,155.9a249.79,249.79,0,0,1,31.7-27.3C106.2,94.2,115.1,60.8,90.9,9.1A58.68,58.68,0,0,1,88.3,0,307.46,307.46,0,0,1,228.4,59.4c89.3,73,78.5,204.3-20.1,252.5a25.32,25.32,0,0,0-9.7,2.5Z",
    transform: "translate(-0.01 0)",
    style: {
      fill: "#ee4854"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotjar);
export default __webpack_public_path__ + "static/media/hotjar.e6a29c973f0c31e585f7a9ebfeb2091d.svg";
export { ForwardRef as ReactComponent };